import { render, staticRenderFns } from "./ClientPaymentsCard.vue?vue&type=template&id=39f4f7e7"
import script from "./ClientPaymentsCard.vue?vue&type=script&lang=js"
export * from "./ClientPaymentsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports